import { Directive, computed, input } from '@angular/core';
import { hlm } from '@spartan-ng/helm/utils';
import { BrnTabsTriggerDirective } from '@spartan-ng/ui-tabs-brain';
import type { ClassValue } from 'clsx';

@Directive({
  selector: '[hlmTabsTrigger]',
  standalone: true,
  hostDirectives: [
    { directive: BrnTabsTriggerDirective, inputs: ['brnTabsTrigger: hlmTabsTrigger', 'disabled'] },
  ],
  host: {
    '[class]': '_computedClass()',
  },
})
export class HlmTabsTriggerDirective {
  public readonly triggerFor = input.required<string>({ alias: 'hlmTabsTrigger' });

  public readonly userClass = input<ClassValue>('');
  protected _computedClass = computed(() =>
    hlm(
      'inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 font-medium ring-offset-background transition-all disabled:pointer-events-none disabled:opacity-50',
      this.userClass(),
    ),
  );
}
